export function getBslAccountNumber(account) {
  return String(account?.AccNumber ?? account?.AccountNumber ?? "").trim();
}

export function findBslOverviewAccount(accounts, accountNumber) {
  const target = String(accountNumber ?? "").trim();
  if (!target || !Array.isArray(accounts)) return null;

  return accounts.find((account) => getBslAccountNumber(account) === target) || null;
}

export function getBslIban(accounts, accountNumber) {
  return findBslOverviewAccount(accounts, accountNumber)?.CurrencyBankDetails?.IBAN || "";
}
